import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "form-dialog__title" }
const _hoisted_2 = {
  class: "form-dialog__content",
  style: {"display":"block"}
}
const _hoisted_3 = { style: {"margin-left":"20px","display":"flex","align-items":"flex-end","flex-wrap":"wrap"} }
const _hoisted_4 = {
  key: 0,
  style: {"width":"100%"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"3px","display":"block"} }, "开票日期", -1)
const _hoisted_6 = { style: {"width":"100%","display":"flex","align-items":"flex-end","flex-wrap":"wrap"} }
const _hoisted_7 = { style: {"margin-right":"15px"} }
const _hoisted_8 = { style: {"display":"block"} }
const _hoisted_9 = { style: {"position":"relative"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "发票号码", -1)
const _hoisted_11 = {
  key: 1,
  style: {"display":"grid","grid-template-columns":"repeat(2, 1fr)","gap":"16px"}
}

import {
  defineModel,
  withDefaults,
  ref,
  computed
} from 'vue';
import {
  BaseForm,
  BaseFormItem,
  BaseInput,
  BaseImage,
  BaseUpload,
  BaseIcon,
  BaseRadioGroup,
  BaseRadio,
  BaseSelect,
  BaseInputNumber,
  BaseDatePicker
} from 'xrk-components';
import { uploadApi } from '@data-source/common/apis';
import { InvoiceApplyDetailListDTO } from '@V/invoice/src/data-source/types';
import { logisticsCode } from '@V/invoice/src/data-source/apis';
import { DetailType, InvoiceFunction, ImportType } from '@V/invoice/src/types';
import { DeleteFilled } from '@element-plus/icons-vue';
import { MAIL_TYPE } from '@V/invoice/src/constants';
import { useRecognition } from '@V/invoice/src/hooks';
import { StateType } from '@cTypes/order';

type FormData = InvoiceApplyDetailListDTO;


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-detail-dialog-file',
  props: /*#__PURE__*/_mergeModels({
    detailType: {},
    id: {},
    importType: { default: 0 },
    invoiceFunction: { default: 1 },
    invoiceBusinessType: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose }) {

const props = __props;

// 蓝、红禁用状态区分
const disabled = !(
  (props.detailType === 2 && props.invoiceFunction === 1) || // 蓝票可编辑
  (props.detailType === 3 && props.invoiceFunction === 2) || // 红票可编辑
  // 补充材料
  [4, 5, 11, 12].includes(props.detailType)
);
const modelValue = _useModel<FormData>(__props, "modelValue"); // 集合中只会有一个元素
const formRef = ref(null);

const formRules = {
  imgList: [
    {
      required: true,
      trigger: 'change',
      validator: (rule, v, callback) => {
        if (!v?.length) {
          return callback(new Error('请上传发票'));
        }
        if (v.some(item => !item.invoicePic)) {
          return callback(new Error('请重新上传发票'));
        }
        if (v.some(item => !item.invoiceAmount || !item.invoiceNo)) {
          return callback(new Error('请填写发票信息'));
        }
        if (v.some(item => !item.invoiceDate && isType7.value)) {
          return callback(new Error('请填写开票日期'));
        }
        callback();
      }
    }
  ],
  fileList: [
    {
      required: false,
      trigger: 'change',
      validator: (rule, v, callback) => {
        if (v.some(item => !item.url)) {
          return callback(new Error('请重新上传资料'));
        }
        callback();
      }
    }
  ],
  isMail: [
    {
      required: true,
      trigger: 'change',
      validator: (rule, v, callback) => {
        const { isMail } = modelValue.value.detail;
        // 不确定后端是否有默认值
        if (
          !+Object.values(MAIL_TYPE)
            .map(item => item.value)
            .includes(isMail)
        ) {
          return callback(new Error('请选择邮寄方式'));
        }
        callback();
      }
    }
  ],
  trackingNo: [
    {
      required: true,
      trigger: 'change',
      validator: (rule, v, callback) => {
        const { isMail, trackingNo } = modelValue.value.detail;
        if (isMail === 1 && !trackingNo) {
          return callback(new Error('请填写单号'));
        }
        callback();
      }
    }
  ],
  companyCode: [
    {
      required: true,
      trigger: 'change',
      validator: (rule, v, callback) => {
        const { isMail, companyCode } = modelValue.value.detail;
        if (isMail === 1 && !companyCode) {
          return callback(new Error('请选择快递公司'));
        }
        callback();
      }
    }
  ]
};
const isType7 = computed(() => props.invoiceBusinessType === 7);

const companyCodeRemote = name => {
  return logisticsCode({
    name
  });
};

const onImgChange = async v => {
  const { response } = v;
  if (response && response.data.fileUrl) {
    const ocr = await useRecognition(response.data.fileUrl);
    modelValue.value.imgList.push({
      id: null,
      invoicePic: response.data.fileUrl,
      invoiceType: props.invoiceFunction,
      invoiceApplyId: props.id,
      remark: null,
      createAt: Date.now(),
      ...ocr
    });
  }
  formRef.value.validate('imgList');
};
const onImgRemove = index => {
  modelValue.value.imgList.splice(index, 1);
  formRef.value.validate('imgList');
};

const onCompanyCodeChange = (v, options) => {
  modelValue.value.detail.companyName = options[0].label;
  modelValue.value.detail.trackingNo = '';
};
const onFilePreview = v => {
  window.open(v.url);
};

__expose({
  validate: (...args: any) => formRef.value?.validate(...args)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseForm), {
    ref_key: "formRef",
    ref: formRef,
    "label-position": "top",
    scrollToError: "",
    model: modelValue.value,
    rules: formRules
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.importType
            ? `补充材料(${_ctx.importType})`
            : `发票-${['', '蓝票', '红票'][_ctx.invoiceFunction]}`), 1)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(BaseFormItem), {
          label: "发票照片",
          prop: "imgList"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              (!disabled)
                ? (_openBlock(), _createBlock(_unref(BaseUpload), {
                    key: 0,
                    style: {"margin-bottom":"20px"},
                    autoUpload: "",
                    btnText: "上传",
                    tipText: "只能上传jpg/png，且每份不超过50MB",
                    listType: null,
                    accept: ['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG'],
                    limit: 20,
                    limitSize: 50,
                    multiple: false,
                    showFileList: false,
                    "http-request": _unref(uploadApi),
                    onChange: onImgChange
                  }, null, 8, ["http-request"]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modelValue.value.imgList, (img, imgIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  style: {"display":"flex","align-items":"flex-end","margin-bottom":"30px"},
                  key: img.invoicePic
                }, [
                  _createVNode(_unref(BaseImage), {
                    style: {"width":"200px","height":"120px"},
                    src: img.invoicePic,
                    "preview-src-list": [img.invoicePic]
                  }, null, 8, ["src", "preview-src-list"]),
                  _createElementVNode("div", _hoisted_3, [
                    (isType7.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _hoisted_5,
                          _createVNode(_unref(BaseDatePicker), {
                            style: {"width":"240px"},
                            type: "date",
                            "validate-event": "",
                            disabled: disabled,
                            modelValue: img.invoiceDate,
                            "onUpdate:modelValue": ($event: any) => ((img.invoiceDate) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("span", _hoisted_8, " 票面金额" + _toDisplayString(_ctx.invoiceFunction === 2 ? '（负）' : ''), 1),
                        _createVNode(_unref(BaseInputNumber), {
                          style: {"width":"240px","display":"block"},
                          placeholder: "请输入",
                          disabled: disabled,
                          controls: false,
                          precision: 2,
                          min: 0,
                          max: 999999999,
                          modelValue: img.invoiceAmount,
                          "onUpdate:modelValue": ($event: any) => ((img.invoiceAmount) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createVNode(_unref(BaseInput), {
                          style: {"width":"240px"},
                          disabled: disabled,
                          modelValue: img.invoiceNo,
                          "onUpdate:modelValue": ($event: any) => ((img.invoiceNo) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        (!disabled)
                          ? (_openBlock(), _createBlock(_unref(BaseIcon), {
                              key: 0,
                              size: "18",
                              color: "#ED7067",
                              style: {"cursor":"pointer","position":"absolute","right":"-40px","bottom":"10px"},
                              onClick: ($event: any) => (onImgRemove(imgIndex))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(DeleteFilled))
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }),
        (!disabled || modelValue.value.fileList?.length)
          ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
              key: 0,
              label: "其他材料",
              prop: "fileList"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseUpload), {
                  style: {"margin-bottom":"20px"},
                  listType: "text",
                  autoUpload: "",
                  showFileList: "",
                  btnText: "添加文件",
                  tipText: 
            disabled ? '' : '只能上传png/jpg/jpeg/pdf/bmp文件，且每份不超过50MB'
          ,
                  accept: ['.jpg', '.jpeg', '.png', '.pdf', '.bmp'],
                  limit: disabled ? 1 : 10,
                  limitSize: 50,
                  multiple: false,
                  "http-request": _unref(uploadApi),
                  disabled: disabled,
                  uploadBtnProps: {
            limitOverHide: true
          },
                  fileList: modelValue.value.fileList,
                  "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((modelValue.value.fileList) = $event)),
                  onPreview: onFilePreview
                }, null, 8, ["tipText", "limit", "http-request", "fileList"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_unref(BaseFormItem), {
          label: "是否邮寄",
          prop: "isMail"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseRadioGroup), {
              disabled: disabled,
              modelValue: modelValue.value.detail.isMail,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue.value.detail.isMail) = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_unref(MAIL_TYPE)), (item) => {
                  return (_openBlock(), _createBlock(_unref(BaseRadio), {
                    key: item.value,
                    value: item.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (modelValue.value.detail.isMail === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_unref(BaseFormItem), {
                label: "快递公司",
                prop: "companyCode"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseSelect), {
                    style: {"width":"100%"},
                    placeholder: "请选择",
                    init: "",
                    clearable: "",
                    filterUseRemote: "",
                    remoteMethod: companyCodeRemote,
                    disabled: disabled,
                    modelValue: modelValue.value.detail.companyCode,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modelValue.value.detail.companyCode) = $event)),
                    onChange: onCompanyCodeChange
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(BaseFormItem), {
                label: "快递单号",
                prop: "trackingNo"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseInput), {
                    style: {"width":"100%"},
                    placeholder: "请输入",
                    disabled: disabled,
                    modelValue: modelValue.value.detail.trackingNo,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modelValue.value.detail.trackingNo) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})